module.exports = __webpack_public_path__ + "img/wi6teAbout.26bbdc44.png";